import styled from "styled-components";

export const InnerBox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 5px;
  padding: ${({ theme }) => theme.padding.small};
  margin: 0;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 2px solid ${({ theme }) => theme.colors.cardColor};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.text};
  font-weight: 500;
  font-size: ${({ theme }) => theme.typography.medium.fontSize};
  transition: border-color 0.5s ease-out;
`;

export const StyledCard = styled.div`
  display: flex;
  gap: 5px;
  padding-right: 5px;
  margin: 0;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.cardColor};
  cursor: pointer;
  transition: background-color 0.5s ease-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};

    ${InnerBox} {
      border: 2px solid ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const CardTitle = styled.h2`
  margin: 0;
  padding: 0;
  font-size: ${({ theme }) => theme.typography.h2.fontSize};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 340px;

  @media (max-width: 480px) {
    width: 300px;
  }
  @media (max-width: 440px) {
    width: 280px;
  }
  @media (max-width: 420px) {
    width: 220px;
  }
  @media (max-width: 360px) {
    width: 140px;
  }
`;

export const TagsFlex = styled.div`
  display: flex;
  gap: 5px;

  @media (max-width: 520px) {
    flex-direction: column;
  }
`;

export const Tag = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 5px;
  background-color: ${({ theme }) => theme.colors.lightGrey};
  border-radius: 10px;
  padding: 5px 10px;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: 500;
  text-wrap: nowrap;
`;

export const TagNumber = styled.p`
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.typography.h2.fontSize};
  font-weight: 500;
  margin: 0;
  padding: 0;
`;

export const ButtonsBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  align-self: center;
  justify-self: center;
`;

export const CardButton = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.white};
  width: 32px;
  height: 32px;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.5s ease-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryLight};
  }
`;
